
































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Table from '@/components/Table/Index.vue';
import ActivityBody from '@/components/Table/ActivityBody.vue';
import Pagination from '@/components/Pagination.vue';
import ActivityData from '@/data/ActivityData';
import { IActivityLog } from '@/interface/Activity';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ActivityModule from '@/store/modules/Activity';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    ActivityBody,
    Table,
    Pagination,
  },
})
export default class ActivityLogLogin extends Mixins(ToolMixin, ErrorHandleMixin, PaginationMixin) {
  TableHeadActivity = ActivityData.TableHead;

  ActivityInstance = getModule(ActivityModule, this.$store);

  userData: Array<IActivityLog> = [
    {
      ipAddress: '',
      timestamp: '',
      role: '',
      username: '',
      originalUrl: '',
    },
  ];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  created() {
    this.fetchActivityLog();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchActivityLog();
  }

  async fetchActivityLog() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.ActivityInstance.FetchActivityLogAgent(
      this.PaginationDetail,
    );
    if (status.code === 0) {
      this.PaginationDetail.amount = data.pageAmount;
      this.userData = [...data.logs];
    }
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }
}
